import { getCurrentStepNumbering } from '../flow-management/stepNumberingSelectors';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from './ExperimentKeys';
import { ExperimentParameterGroup } from './ExperimentParameterGroup';
export const getTotalSteps = state => {
  const {
    totalSteps
  } = getCurrentStepNumbering(state);
  const isACQ0149Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0149, [ExperimentParameterGroup.Variant_A]);
  let additionalTotalSteps = 0;
  if (isACQ0149Variant) {
    // Adding the default 5 steps shown in the setup flow
    additionalTotalSteps = 5;
  }
  return totalSteps + additionalTotalSteps;
};